import { jsx } from '@emotion/react/jsx-runtime';
import { createPolymorphicComponent, useSlot } from '@nettbureau/core';
import { useCss, inset } from '@nettbureau/styling';

/**
 * Backdrop is a component that darkens the page behind a modal, to focus attention on a specific
 * element, blocking interaction with other parts of the page.
 */ const Backdrop = createPolymorphicComponent((props, forwardedRef)=>{
    const [mergedProps, mergedRef] = useSlot('Backdrop', props, forwardedRef);
    const { as: Component = 'div', css, transparent = false, ...otherProps } = mergedProps;
    const backdropCss = useCss(({ theme, mixins })=>[
            {
                position: 'fixed'
            },
            !transparent && {
                background: theme.aliases.tintColors.darken.strong
            },
            inset(0),
            mixins.zIndex('lg')
        ]);
    return /*#__PURE__*/ jsx(Component, {
        "data-backdrop": true,
        ...otherProps,
        ref: mergedRef,
        css: [
            backdropCss,
            css
        ]
    });
});

export { Backdrop };
//# sourceMappingURL=backdrop.js.map
